<template>
	<div class="certificate-page">
		<!-- 顶部标题区域 -->
		<header>
			<div class="head-wrap">
				<div class="logo">
					<img src="../assets/images/home_logo1.png" alt="" />
				</div>
				<!-- <div>
					<h1>中小企业数字化综合服务公共平台</h1>
					<p>中小企业技能人才及企业服务管理能力考核信息查询平台</p>
					<p>SME Digital Integrated Service Public Platform</p>
				</div> -->
			</div>
		</header>

		<!-- 主要内容区域 -->
		<main>
			<div class="container">
				<div class="grid-container">
					<div class="category-card" v-if="rencai.length">
						<!-- 类别标题 -->
						<div class="category-header">
							<div class="flex items-center">
								<div class="category-icon-bg">
									<img src="../assets/images/index_icon1.png">
								</div>
								<h2 class="category-title">人才信息查询</h2>
							</div>
						</div>

						<!-- 证书列表 -->
						<div class="cert-list">
							<div v-for="(cert,index) in rencai" :key="index" class="cert-item">
								<div class="cert-content">
									<!-- 证书图片 -->
									<div class="cert-image">
										<img :src="cert.img" :alt="cert.name" />
									</div>

									<!-- 证书内容 -->
									<div class="cert-text">
										<h3>{{ cert.name }}</h3>
										<button @click="handleQueryClick(cert,1)" class="query-btn">
											<img src="../assets/images/search.png" alt="">
											进入查询
										</button>
									</div>
								</div>
							</div>
							<div>
								<div class="desc-title">证书说明</div>
								<div>
									<p class="cert-desc" v-for="(item,index) in rencaiList" :key="index">{{ item.key }}
									</p>
								</div>
							</div>
							<!--              <div v-if="qiye.length === 0" class="no-cert">-->
							<!--                没有找到相关证书-->
							<!--              </div>-->
						</div>
					</div>
					<div class="category-card" v-if="qiye.length">
						<!-- 类别标题 -->
						<div class="category-header">
							<div class="flex items-center">
								<div class="category-icon-bg">
									<img src="../assets/images/index_icon2.png">
								</div>
								<h2 class="category-title">企业信息查询</h2>
							</div>
						</div>

						<!-- 证书列表 -->
						<div class="cert-list">
							<div v-for="(cert,index) in qiye" :key="index" class="cert-item">
								<div class="cert-content">
									<!-- 证书图片 -->
									<div class="cert-image">
										<img :src="cert.img" :alt="cert.name" />
									</div>

									<!-- 证书内容 -->
									<div class="cert-text">
										<h3>{{ cert.name }}</h3>
										<button @click="handleQueryClick(cert,2)" class="query-btn">
											<img src="../assets/images/search.png" alt="">
											进入查询
										</button>
									</div>
								</div>
							</div>
							<div>
								<div class="desc-title">证书说明</div>
								<div>
									<p class="cert-desc" v-for="(item,index) in qiyeList" :key="index">{{ item.key }}
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="category-card" v-if="qiyerongyu.length">
						<!-- 类别标题 -->
						<div class="category-header">
							<div class="flex items-center">
								<div class="category-icon-bg">
									<img src="../assets/images/index_icon3.png">
								</div>
								<h2 class="category-title">企业荣誉信息查询</h2>
							</div>
						</div>

						<!-- 证书列表 -->
						<div class="cert-list">
							<div v-for="(cert,index) in qiyerongyu" :key="index" class="cert-item">
								<div class="cert-content">
									<!-- 证书图片 -->
									<div class="cert-image">
										<img :src="cert.img" :alt="cert.name" />
									</div>

									<!-- 证书内容 -->
									<div class="cert-text">
										<h3>{{ cert.name }}</h3>
										<button @click="handleQueryClick(cert,3)" class="query-btn">
											<img src="../assets/images/search.png" alt="">
											进入查询
										</button>
									</div>
								</div>
							</div>
							<div>
								<div class="desc-title">证书说明</div>
								<div>
									<p class="cert-desc" v-for="(item,index) in qiye_rongyuList" :key="index">
										{{ item.key }}</p>
								</div>
							</div>
							<!--              <div v-if="qiye.length === 0" class="no-cert">-->
							<!--                没有找到相关证书-->
							<!--              </div>-->
						</div>
					</div>
					<div class="category-card" v-if="qiyeuser.length">
						<!-- 类别标题 -->
						<div class="category-header">
							<div class="flex items-center">
								<div class="category-icon-bg">
									<img src="../assets/images/index_icon4.png">
								</div>
								<h2 class="category-title">企业会员信息查询</h2>
							</div>
						</div>

						<!-- 证书列表 -->
						<div class="cert-list">
							<div v-for="(cert,index) in qiyeuser" :key="index" class="cert-item">
								<div class="cert-content">
									<!-- 证书图片 -->
									<div class="cert-image">
										<img :src="cert.img" :alt="cert.name" />
									</div>

									<!-- 证书内容 -->
									<div class="cert-text">
										<h3>{{ cert.name }}</h3>
										<button @click="handleQueryClick(cert,4)" class="query-btn">
											<img src="../assets/images/search.png" alt="">
											进入查询
										</button>
									</div>
								</div>
							</div>
							<div>
								<div class="desc-title">证书说明</div>
								<div>
									<p class="cert-desc" v-for="(item,index) in qiye_huiyuanList" :key="index">
										{{ item.key }}</p>
								</div>
							</div>
							<!--              <div v-if="qiye.length === 0" class="no-cert">-->
							<!--                没有找到相关证书-->
							<!--              </div>-->
						</div>
					</div>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
	import {
		index_list,
		index_config
	} from "@/api/index";
	export default {
		name: 'CertificateQueryPage',
		data() {
			return {
				qiye: [],
				qiyerongyu: [],
				qiyeuser: [],
				rencai: [],

				qiye_huiyuanList: [],
				qiye_rongyuList: [],
				qiyeList: [],
				rencaiList: [],
			}
		},
		mounted() {
			this.getType()
			this.getConfig()
		},
		methods: {
			getType() {
				index_list().then(res => {
					if (res.code == 1) {
						this.qiye = res.data.qiye;
						this.qiyerongyu = res.data.qiyerongyu;
						this.qiyeuser = res.data.qiyeuser;
						this.rencai = res.data.rencai;
					}
				})
			},
			getConfig() {
				index_config().then(res => {
					if (res.code == 1) {
						this.qiye_huiyuanList = res.data.qiye_huiyuan;
						this.qiye_rongyuList = res.data.qiye_rongyu;
						this.qiyeList = res.data.qiye;
						this.rencaiList = res.data.geren;
					}
				})
			},

			toggleCategory(category) {
				this.$set(this.expandedCategories, category, !this.expandedCategories[category])
			},
			filterCertificates(category, certs) {
				if (!this.searchTerm.trim()) return certs
				return certs.filter(cert =>
					cert.title.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
					cert.description.some(desc => desc.toLowerCase().includes(this.searchTerm.toLowerCase()))
				)
			},
			handleQueryClick(item, num) {
				if (num == 1) {
					this.$router.push({
						path: '/user',
						query: {
							name: item.name,
							type: num,
							typeId: item.id
						}
					})
				} else {
					this.$router.push({
						path: '/firm',
						query: {
							name: item.name,
							type: num,
							typeId: item.id
						}
					})
				}
			},
		}
	}
</script>

<style scoped lang="scss">
	.certificate-page {
		/* 整体布局 */
		display: flex;
		flex-direction: column;
		min-height: 100vh;
		background-image: url("../assets/images/bg.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		color: white;
		font-family: system-ui, -apple-system, sans-serif;

		/* 公共变量 */
		--white-10: rgba(255, 255, 255, 0.1);
		--white-15: rgba(255, 255, 255, 0.15);
		--white-20: rgba(255, 255, 255, 0.2);
		--white-30: rgba(255, 255, 255, 0.3);
		--white-70: rgba(255, 255, 255, 0.7);
		--white-80: rgba(255, 255, 255, 0.8);
		--blue-600-80: rgba(37, 99, 235, 0.8);
		--blue-700-80: rgba(29, 78, 216, 0.8);

		/* 容器 */

		& .container {
			width: 100%;
			max-width: 100%;
			margin: 0 auto;
			padding: 0 1rem;

			@media (min-width: 768px) and (max-width: 1400px) {
				max-width: 90%;
			}

			@media (min-width: 1400px) {
				max-width: 70%;
			}
		}

		.head-wrap {
			display: flex;
			align-items: center;
		}

		/* 通用工具类（保留少量必要结构） */

		& .flex {
			display: flex;
		}

		& .items-center {
			align-items: center;
		}

		& .mb-4 {
			margin-bottom: 1rem;
		}

		@media (min-width: 768px) {
			& .md-mb-0 {
				margin-bottom: 0;
			}
		}

		/* 顶部标题区域 */

		& header {
			padding: 1rem 1rem;
			box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
			background-color: var(--white-10);
			backdrop-filter: blur(12px);

			@media (min-width: 768px) {
				padding: 1.25rem 3rem;
			}
		}

		& .logo {
			margin-right: .8rem;

			@media (min-width: 768px) {
				margin-right: 1rem;
			}
		}

		& .logo img {
			width: 100%;
			// height: 3.3rem;

			@media (min-width: 768px) {
				// width: 5rem;
				// height: 5rem;
			}
		}

		& h1 {
			font-size: 1rem;
			font-weight: 700;
			letter-spacing: 6px;

			@media (min-width: 768px) {
				font-size: 1.25rem;
				letter-spacing: 10.7px;
			}
		}

		& header p {
			font-size: .81rem;
			opacity: 0.9;
			margin-top: .1rem;

			@media (min-width: 768px) {
				font-size: 1.12rem;
			}
		}

		& header p:nth-child(3) {
			font-size: 0.75rem;
			margin-top: .3rem;
		}

		/* 主内容区 */

		& main {
			flex-grow: 1;
			padding: 1.5rem 0;
		}

		& .category-card {
			background-color: var(--white-10);
			backdrop-filter: blur(12px);
			border-radius: 0.75rem;
			box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
			border: 1px solid var(--white-20);
			overflow: hidden;
			margin-bottom: 1rem;
		}

		& .category-header {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 1rem 1.5rem;
			background: linear-gradient(to right, var(--blue-600-80), var(--blue-700-80));
			cursor: pointer;
		}

		& .category-icon-bg {
			background-color: var(--white-20);
			padding: 0.6rem;
			border-radius: 0.5rem;
			margin-right: 0.75rem;

			img {
				width: 1.5rem;
				height: 1.5rem;
			}
		}

		& .category-title {
			font-size: 1.125rem;
			font-weight: 700;
		}

		& .cert-list {
			padding: 1.2rem;
		}

		& .cert-item {
			background-color: var(--white-15);
			backdrop-filter: blur(8px);
			border-radius: 0.5rem;
			padding: 1rem;
			margin-bottom: 0.75rem;
			transition: all 0.3s ease;
		}

		& .cert-item:hover {
			background-color: var(--white-20);
		}

		& .cert-content {
			display: flex;
			flex-direction: column;
			gap: 1.2rem;
		}

		& .cert-image {
			width: 100%;
			height: 12rem;
			flex-shrink: 0;
		}

		@media (min-width: 768px) {
			& .cert-content {
				flex-direction: row;
			}

			& .cert-image {
				width: 12rem;
				height: 8rem;
				flex-shrink: 0;
			}
		}

		& .cert-image img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			border-radius: 0.5rem;
			box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
			// object-fit:;
		}

		& .cert-text {
			display: flex;
			flex-direction: column;
			justify-content: space-around;
			flex: 1;
		}

		& .cert-text h3 {
			font-weight: 700;
			margin-bottom: 1rem;
			color: white;
			font-size: 1rem;
		}

		@media (min-width: 768px) {
			& .cert-text h3 {
				font-size: 1.3rem;
				margin-bottom: 0.5rem;
			}
		}

		& .desc-title {
			font-size: 1.3rem;
			text-align: center;
			margin-bottom: 1rem;
			padding-top: .5rem;
		}

		& .cert-desc {
			font-size: 0.85rem;
			color: var(--white-80);
			line-height: 1.625;
			margin-bottom: .8rem;
		}

		& .query-btn {
			background: linear-gradient(to right, #3b82f6, #2563eb);
			color: white;
			padding: 0.375rem 1rem;
			border-radius: 9999px;
			font-size: 0.875rem;
			display: flex;
			align-items: center;
			justify-content: center;
			box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
			transition: all 0.3s ease;
			border: none;
			cursor: pointer;
			width: max-content;

			img {
				width: .9rem;
				height: .9rem;
				margin-right: 0.5rem;
			}
		}

		& .query-btn:hover {
			box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
		}

		& .query-btn svg {
			width: 14px;
			height: 14px;
			margin-right: 0.25rem;
		}

		& .no-cert {
			text-align: center;
			padding: 1rem 0;
			font-size: 0.875rem;
			color: var(--white-70);
		}

		& .global-no-result {
			grid-column: span 1 / span 1;
			text-align: center;
			padding: 3rem 0;
			font-size: 1.125rem;
			color: var(--white-70);
		}

		@media (min-width: 768px) {
			& .global-no-result {
				grid-column: span 2 / span 2;
			}
		}

		& .clear-search-btn {
			margin-top: 1rem;
			background-color: var(--white-20);
			color: white;
			padding: 0.5rem 1rem;
			border-radius: 9999px;
			font-size: 0.875rem;
			transition: background-color 0.3s;
			border: none;
			cursor: pointer;
		}

		& .clear-search-btn:hover {
			background-color: var(--white-30);
		}

		/* 页脚 */

		& footer {
			padding: 0.75rem 1rem;
			text-align: center;
			font-size: 0.75rem;
			opacity: 0.7;
			border-top: 1px solid var(--white-10);
		}

		/* 网格布局 */

		& .grid-container {
			display: grid;
			gap: 1rem;
			grid-template-columns: repeat(1, minmax(0, 1fr));
		}

		@media (min-width: 768px) {
			& .grid-container {
				grid-template-columns: repeat(2, minmax(0, 1fr));
			}
		}
	}
</style>
